import { v4 as uuidv4 } from "uuid";

/**
 * Genera un UUID v4 criptográficamente seguro (navegador y webview Tauri).
 * Utiliza el paquete estándar 'uuid' que hace uso interno de la Web Crypto API (crypto.getRandomValues).
 */
export function generateUUID(): string {
  return uuidv4();
}
